var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "multi-select__list" },
    _vm._l(_vm.select.options, function(option) {
      return _c("li", { key: option.id, staticClass: "multi-select__item" }, [
        _c(
          "div",
          { staticClass: "checkbox checkbox_size_small checkbox_theme_dark" },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: option.selected,
                  expression: "option.selected"
                }
              ],
              staticClass: "checkbox__input",
              attrs: {
                type: "checkbox",
                name: _vm.select.name,
                id: _vm.select.name + "-" + option.id + "-" + _vm.view,
                disabled: option.disabled
              },
              domProps: {
                value: option.value,
                checked: Array.isArray(option.selected)
                  ? _vm._i(option.selected, option.value) > -1
                  : option.selected
              },
              on: {
                change: [
                  function($event) {
                    var $$a = option.selected,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = option.value,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(option, "selected", $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            option,
                            "selected",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(option, "selected", $$c)
                    }
                  },
                  _vm.change
                ]
              }
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "checkbox__label",
                attrs: {
                  for: _vm.select.name + "-" + option.id + "-" + _vm.view
                }
              },
              [
                _c("span", { staticClass: "checkbox__icon" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "11",
                        height: "8",
                        viewBox: "0 0 11 8",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [_c("path", { attrs: { d: "M1 3L4.5 6.5L10 1" } })]
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "checkbox__text" }, [
                  _vm._v(_vm._s(option.text))
                ])
              ]
            )
          ]
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }